import React from "react";
import CONFIG from "../../../../config";

import sberbankLogo from '../../../../assets/img/where-pay/sber-logo.svg';

const { LINKS } = CONFIG;

const SberItem: React.FC = () => (
    <div className="where__pay__item green">
        <div className="where__pay__title">
            <img src={sberbankLogo} alt="ПАО ”Сбербанк”" />
            <span>ПАО ”Сбербанк”</span>
        </div>
        <div className="where__pay__link">
            <ul className="where__pay__ul">
                <li><span>Комиссия банка, действующая на момент оплаты</span></li>
                <li><span>Зачисление на следующий рабочий день</span></li>
            </ul>
        </div>
        <div className="where__pay__link">
            <a href={LINKS.SBERBANK.OIB} target="_blank" rel="noopener noreferrer nofollow">В отделениях</a>
        </div>
        <div className="where__pay__link">
            <a href={LINKS.SBERBANK.OIB} target="_blank" rel="noopener noreferrer nofollow">В банкоматах и терминалах</a>
        </div>
        <div className="where__pay__link">
            <a href={LINKS.SBERBANK.INNER_APPS} target="_blank" rel="noopener noreferrer nofollow">На сайте и в мобильном приложении</a>
        </div>
    </div>
);

export default SberItem;